import { render, staticRenderFns } from "./ToznyTextarea.vue?vue&type=template&id=88026276&scoped=true&"
import script from "./ToznyTextarea.vue?vue&type=script&lang=js&"
export * from "./ToznyTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ToznyTextarea.vue?vue&type=style&index=0&id=88026276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88026276",
  null
  
)

export default component.exports